export const convertPrice = (priceInCents, currency) => {
  let parsedPrice = parseInt(priceInCents) / 100;

  if (isNaN(parsedPrice)) {
    parsedPrice = 0;
  }

  try {
    const intl = new Intl.NumberFormat('en-EN', { style: 'currency', currency });
    return intl.format(parsedPrice);
  } catch (error) {
    console.log('Invalid currency passed to convertPrice', error.message);
    return parsedPrice.toString();
  }
};
